import { Component, input } from '@angular/core';
import { SonaFaviconComponent } from '@sona/angular-ui-components';
import { ITarget } from '@sona/shared-model-common';

@Component({
    selector: 'sona-target-breadcrumb',
    templateUrl: './target-breadcrumb.component.html',
    imports: [SonaFaviconComponent],
    styleUrl: './target-breadcrumb.component.scss'
})
export class SonaTargetBreadcrumbComponent {
    readonly target = input.required<ITarget>();
}
